module.exports = __webpack_public_path__ + "static/media/rss-updates-subscription-svgrepo-com.8b10ff7d.svg";